import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import PageLayout from "../layouts/PageLayout";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";

const File1 = `${process.env.PUBLIC_URL}/Согласие на заключение договора.docx`;
const File2 = `${process.env.PUBLIC_URL}/Согласие родителей на перемещение.docx`;

const File3 = `${process.env.PUBLIC_URL}/согласие_газпромбанк.docx`;
const File4 = `${process.env.PUBLIC_URL}/согласие_сбербанк.docx`;
const File5 = `${process.env.PUBLIC_URL}/согласие_втб.pdf`;

export default function TomichamPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageLayout>
      <div className="container my-2">
        <NavLink to="/" className="btn btn-success mt-3">
          <FontAwesomeIcon icon={faCaretLeft} /> На главную
        </NavLink>
        <h1 className="my-4 title-page-guide">
          Первые шаги первокурсника ТПУ: для томичей
        </h1>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-10">
            <div className="guide-box">
              <p>
                Поздравляем, ты зачислен в Национальный исследовательский
                Томский политехнический университет! Ниже — небольшой чек-лист с
                самой важной информацией, которая пригодится тебе в ближайшее
                время.
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">Корпоративный логин и пароль</div>
              <p>
                На твой e-mail, указанный в заявлении, выслан логин и пароль для
                доступа в{" "}
                <a href="https://lk.tpu.ru" target="_blank">
                  личный кабинет
                </a>{" "}
                студента ТПУ и ко всем ресурсам университета, в том числе,
                запись на регистрацию в общежитие. В случае, если информация не
                пришла на почту или возникли трудности, напиши на адрес{" "}
                <a href="mailto:login_problem@tpu.ru">login_problem@tpu.ru</a>.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">Посетить Единый деканат</div>
              <p>
                Единый деканат ТПУ находится в Научно-технической библиотеке ТПУ
                по адресу ул. Белинского, 53а, офис № 117.
              </p>
              <p>
                Режим работы:
                <ul>
                  <li>с 24.08.26 по 01.09.26, с 09:00 до 20:00 без перерывов и выходных;</li>
                  <li>с 02.09.26 и далее, с 09:00 до 17:00, без перерыва, сб, вс – выходной.</li>
                </ul>
              </p>
              <p>Здесь нужно в первую очередь:</p>
              <ol>
                <li>Сфотографироваться и получить пропуск;</li>
                <li>Сверить личные данные;</li>
                <li>
                  Подписать согласие на обработку и распространение персональных
                  данных;
                </li>
                <li>
                  Ознакомиться с правилами внутреннего распорядка обучающихся;
                </li>
                <li>
                  Для несовершеннолетних — принести подписанное{" "}
                  <a href={File1} download>
                    согласие родителей на заключение договора
                  </a>
                  ;
                </li>
                <li>
                  Для несовершеннолетних — принести подписанное{" "}
                  <a href={File2} download>
                    согласие родителей на перемещение
                  </a>
                  .
                </li>
              </ol>
            </div>
          </div>
        </div>
        <div className="row">
          <p>
            <strong>Возьми с собой паспорт и СНИЛС!</strong>
          </p>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">
                Получить банковскую карту для стипендии
              </div>
              <p>
                Информация о дате и месте получения придет дополнительно на ваш
                адрес электронной почты ТПУ.
              </p>
              <p>
                Для несовершеннолетних необходимо заполнить согласие родителей
                на выдачу карты:
                <ul>
                  <li>БШ - <a href={File4} download>Сбербанк;</a></li>
                  <li>ИШИиЭС - <a href={File4} download>Сбербанк;</a></li>
                  <li>ИШИТР - <a href={File4} download>Сбербанк;</a></li>
                  <li>ИШНКБ - <a href={File4} download>Сбербанк;</a></li>
                  <li>ИЯТШ - <a href={File3} download>Газпромбанк;</a></li>
                  <li>ИШПР - <a href={File3} download>Газпромбанк;</a></li>
                  <li>ИШЭ - <a href={File5} download>ВТБ;</a></li>
                  <li>ШОН - <a href={File5} download>ВТБ;</a></li>
                  <li>ИШНПТ - <a href={File5} download>ВТБ.</a></li>
                </ul>
              </p>
            </div>
          </div>
        </div>
        {/* <div className="row">
          <div className="col-12">
            <div className="guide-box">
              <div className="title back_gc1">
                Информация для несовершеннолетних
              </div>
              <p>
                Если тебе еще нет 18 лет, то для тебя актуальная вся информацию
                выше. Плюс, тебе необходимо передать в Единый деканат
                подписанное согласие родителей на перемещение. И для получения
                банковской карты также нужно заполнить согласие родителей на
                выдачу карты.
              </p>
            </div>
          </div>
        </div> */}
        Информация для парней по 2 отделу:
        <ol type="">
          <li>Взять приписное с собой в Томск;</li>
          <li>
            Вместе с приписным посетить Главный корпус ТПУ (пр. Ленина, 30,
            кабинет № 120) после получения временной регистрации в Томске.
          </li>
        </ol>
      </div>
    </PageLayout>
  );
}
